import api from './api';
import { AWARDING_RULE_SETS_TAG } from './awardingRuleSets';
import { ADMIN_BID_SETUPS_TAG } from './bidSetups';

export { AWARDING_RULE_SETS_TAG, ADMIN_BID_SETUPS_TAG };

export default {
    [api.reducerPath]: api.reducer,
};
